import React, { Component } from 'react';
import { Image } from 'semantic-ui-react'
import { authContext } from '../adalConfig';
import './ConfirmationPage.css';
import checkcomplete from '../img/checkcomplete.png';
import ProHeader from './Pro/ProHeader';
import ProFooter from './Pro/ProFooter';
import RHHeader from './Corp/RHHeader';
import RHFooter from './Corp/RHFooter';


class ConfirmationPage extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        userRole: '',
        region: ''
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.setState({
                userRole: this.props.location.state.passedUserRole,
                region: this.props.location.state.passedRegion,
                country: this.props.location.state.passedCountry
            }, () => {
                console.log(this.state.userRole);
            });
        }
        else {
            this.props.history.push('./unauthorized');
        }
    }

    handleHeaderSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProHeader />;
        else if (this.state.userRole === 'CORPORATE' || this.state.userRole === 'FIELD')
            return <RHHeader />;
    }

    handleFooterSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProFooter />;
        else if (this.state.userRole === 'CORPORATE' || this.state.userRole === 'FIELD')
            return <RHFooter />;
    }

    handleThanks() {
        if (this.state.country === 'DE')
            return <p className="thank-you">Danke!</p>;
        else if (this.state.country === 'FR')
            return <p className="thank-you">Merci!</p>;
        else
            return <p className="thank-you">Thank you!</p>;
    }

    handleEmeaEmail() {
        if (this.state.region === 'EMEA' && this.state.country === 'DE') {
            if (this.state.userRole === "PROTIVITI") {
                return (
                    <p className="confirmation-description">Du hast dich erfolgreich registriert, um deinen Protiviti-Computer zu aktualisieren. Du wirst in Kürze eine E-Mail-Bestätigung erhalten.<br /><br />
                        Wenn du Änderungen an deiner Anmeldung vornehmen willst oder Fragen hast, wende dich bitte an<br /><a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Asset Management Team</em></a>.</p>
                )
            } else {
                return (
                    <p className="confirmation-description">Du hast dich erfolgreich registriert, um deinen Robert Half-Computer zu aktualisieren. Du wirst in Kürze eine E-Mail-Bestätigung erhalten.<br /><br />
                        Wenn du Änderungen an deiner Anmeldung vornehmen willst oder Fragen hast, wende dich bitte an<br /><a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Asset Management Team</em></a>.</p>
                )
            }
        }
        else if (this.state.region === 'EMEA' && this.state.country === 'FR') {
            if (this.state.userRole === "PROTIVITI") {
                return (
                    <p className="confirmation-description">Vous vous êtes enregistré avec succès pour actualiser votre ordinateur Protiviti. Vous recevrez un e-mail de confirmation sous peu.<br /><br />
                        Si vous devez apporter des modifications à votre inscription, ou si vous avez des questions, veuillez contacter<br /><a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Assets Management Team</em></a>.</p>
                )
            } else {
                    return (
                        <p className="confirmation-description">Vous vous êtes enregistré avec succès pour actualiser votre ordinateur Robert Half. Vous recevrez un e-mail de confirmation sous peu.<br /><br />
                            Si vous devez apporter des modifications à votre inscription, ou si vous avez des questions, veuillez contacter<br /><a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Assets Management Team</em></a>.</p>
                    )
            }
        }
        else if (this.state.region === 'EMEA' && (this.state.country === 'GB' || this.state.country === 'LU' || this.state.country === 'BE' || this.state.country === 'NL' || this.state.country === 'CH' || this.state.country === 'IE'))
            return (
                <p className="confirmation-description">You have successfully registered for a refresh computer. You will receive an email confirmation shortly.<br /><br />
                    If you need to make changes to your registration, or have any questions, please contact <br /> <a href='mailto:AssetsManagementRegistrationSite@roberthalf.net'><em>EMEA Assets Management Team</em></a>.</p>
            )
    }

    handleUserRole() {
        if (this.state.region === 'NA' && this.state.userRole === 'PROTIVITI')
            return (
                <p className="confirmation-description">You have successfully registered to refresh your Protiviti computer. You will receive an email confirmation shortly.<br /><br />
                    If you need to make changes to your registration, or have any questions, please contact <br /> <a href='mailto:NAProtivitiUpgrades@protiviti.com'><em>NAProtivitiUpgrades@protiviti.com</em></a>.</p>
            )
        else if (this.state.region === 'NA' && this.state.userRole === 'CORPORATE')
            return (
                <p className="confirmation-description">You have successfully registered to upgrade your Robert Half computer. You will receive an email confirmation shortly.<br /><br />
                    If you need to make changes to your registration, or have any questions, please contact <br /> <a href='mailto:NACorpUpgrades@roberthalf.com'><em>NACorpUpgrades@roberthalf.com</em></a>.</p>
            )
        else if (this.state.region === 'NA' && this.state.userRole === 'FIELD')
            return (
                <p className="confirmation-description">You have successfully registered to upgrade your Robert Half Talent Solutions computer. You will receive an email confirmation shortly.<br /><br />
                    If you need to make changes to your registration, or have any questions, please contact <br /> <a href='mailto:upgrades@roberthalf.com'><em>upgrades@roberthalf.com</em></a>.</p>
            )
    }

    render() {
        return (
            <div className='outer-container'>
                <div className='inner-container'>
                    {this.handleHeaderSelection()}
                
                    <div className="confirmation-container">

                        <Image src={checkcomplete} className="check-complete-img" />
                        {this.handleThanks()}
                        {this.handleUserRole()}
                        {this.handleEmeaEmail()}
                    </div>
                </div>
                {this.handleFooterSelection()}

            </div>
           
        );
    }
}


export default ConfirmationPage;
